import { render, staticRenderFns } from "./Bulletin.vue?vue&type=template&id=bc8df0ee&scoped=true"
import script from "./Bulletin.vue?vue&type=script&lang=js"
export * from "./Bulletin.vue?vue&type=script&lang=js"
import style0 from "./Bulletin.vue?vue&type=style&index=0&id=bc8df0ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc8df0ee",
  null
  
)

export default component.exports